import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import readmePreHtml from './ReadmePreBlock.html';
import readmePostHtml from './ReadmePostBlock.html';
import TerminalWrapper from '~/Pages/TryDocpie/TerminalWrapper';
export default (function () { return _jsxs(_Fragment, { children: [_jsx("div", { dangerouslySetInnerHTML: { __html: readmePreHtml } }), _jsx(TerminalWrapper, {}), _jsx("hr", {}), _jsx("div", { dangerouslySetInnerHTML: { __html: readmePostHtml } })] }); });
